import styled from "styled-components";

export const StageNavbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;